import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=7a88a342&scoped=true&lang=pug"
import script from "./SortableItem.vue?vue&type=script&lang=js"
export * from "./SortableItem.vue?vue&type=script&lang=js"
import style0 from "./SortableItem.vue?vue&type=style&index=0&id=7a88a342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a88a342",
  null
  
)

export default component.exports